import { getLocalizedMessage } from '@/core/shared'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'

export function richTextEditor (vm) {
	let richTextElement = ''
	const localeSystem = vm.$store.getters.getLocale


	// batch update
	let batchUpdateModal = $('#batch-update-form')
	let area = "#" + vm.attributeName + "__area"
	let richTextInput = $(area).find("input")
	let richTextView = richTextInput.closest(area).find(".rich-text-editor-default")
	if (vm.type === 'SL') {
		richTextInput = $("#" + vm.attributeName + "__" + vm.language)
		richTextView = richTextInput.closest(area).find(".rich-text-editor-default")
	}
	let richTextInputValue = richTextInput.val()

	Swal.fire({
		title: '<h3>' + (vm.language ? vm.$t(vm.localizedTitle) + ' ' + vm.language : vm.$t(vm.localizedTitle)) + '</h3>',
		html: '<div id="rich-text-editor" class="rich-text-editor-default" style="text-align: left"></div>',
		buttonsStyling: false,
		confirmButtonText: getLocalizedMessage('save'),
		showCancelButton: true,
		cancelButtonText: getLocalizedMessage('cancel'),
		allowOutsideClick: false,
		allowEscapeKey: false,
		allowEnterKey: true,
		position: 'top',
		showClass: {
			popup: ''
		},
		hideClass: {
			popup: ''
		},
		customClass: {
			container: 'rich-text-modal',
			confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
			cancelButton: 'uk-button uk-button-default uk-button-small',
		},
		onRender: function (el) {
			richTextElement = $(el).find('#rich-text-editor')

			// batch update
			if(batchUpdateModal.length) {
				batchUpdateModal.hide()
			}
		},
		onOpen: function (el) {
			richTextElement.trumbowyg({
				lang: localeSystem === 'ee' ? 'et' : localeSystem,
				resetCss: true,
				autogrow: true,
				tagsToRemove: ['script', 'link'],
				btns: [
					['viewHTML'],
					['undo', 'redo'],
					['fontfamily', 'fontsize', 'formatting'],
					['strong', 'em', 'del'],
					['superscript', 'subscript'],
					['link'],
					['insertImage'],
					['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
					['unorderedList', 'orderedList'],
					['removeformat'],
					['horizontalRule'],
					['fullscreen']
				]
			})

			if (vm.attributeValue) {
				richTextElement.trumbowyg('html', vm.attributeValue)
			}

			// batch update
			if(batchUpdateModal.length && richTextInputValue) {
				richTextElement.trumbowyg('html', richTextInputValue)
			}
		},
		onDestroy: function () {
			richTextElement.trumbowyg('destroy')

			// batch update
			if(batchUpdateModal.length) {
				batchUpdateModal.show()
			}
		}
	}).then((result) => {
		if (result.value) {
			let value = richTextElement.trumbowyg('html')

			if (vm.type === 'SL') {
				if (vm.itemData !== null) {
					if (!vm.itemData[vm.attributeName]) {
						vm.$set(vm.itemData, vm.attributeName, {})
					}

					vm.$set(vm.itemData[vm.attributeName], vm.language, value)
				} else {
					// batch update
					richTextInput.val(value)
					richTextView.html(value)
				}
			} else {
				vm.$set(vm.itemData, vm.attributeName, value)
				richTextInput.val(value)
				richTextView.html(value)
			}
			vm.$nextTick(() => {
				attributeChangesRegister(vm.attributeName)
			})
		}
	})
}
